'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reduxAsyncConnect = require('redux-async-connect');

var _documents = require('redux/modules/documents');

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Documents = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  deferred: false,
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState;

    if (!(0, _documents.isLoaded)(getState())) {
      return dispatch((0, _documents.load)());
    }
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    documents: state.documents.data
  };
}), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Documents, _Component);

  function Documents() {
    (0, _classCallCheck3.default)(this, Documents);
    return (0, _possibleConstructorReturn3.default)(this, (Documents.__proto__ || (0, _getPrototypeOf2.default)(Documents)).apply(this, arguments));
  }

  (0, _createClass3.default)(Documents, [{
    key: 'render',
    value: function render() {
      var documents = this.props.documents;


      console.log('documents in render method', documents);
      var styles = require('./Documents.scss');
      // require the logo image both from client and server
      return _react2.default.createElement(
        'div',
        { className: styles.documents },
        _react2.default.createElement(
          'section',
          { className: styles.box },
          _react2.default.createElement(
            'h1',
            { className: styles.boxTitle },
            'Documents'
          ),
          _react2.default.createElement('div', { className: styles.boxBar })
        ),
        _react2.default.createElement(
          'div',
          { className: styles.content },
          _react2.default.createElement(
            'section',
            { className: styles.box },
            _react2.default.createElement(
              'h2',
              { className: styles.boxSubtitle },
              'Liste des documents'
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'table',
                { className: styles.listing },
                _react2.default.createElement(
                  'thead',
                  null,
                  _react2.default.createElement(
                    'tr',
                    null,
                    _react2.default.createElement(
                      'th',
                      null,
                      '#'
                    ),
                    _react2.default.createElement(
                      'th',
                      null,
                      'Type'
                    ),
                    _react2.default.createElement(
                      'th',
                      null,
                      'Derni\xE8re mise \xE0 jour'
                    ),
                    _react2.default.createElement(
                      'th',
                      null,
                      'Publi\xE9'
                    ),
                    _react2.default.createElement('th', null),
                    _react2.default.createElement(
                      'th',
                      null,
                      'Actions'
                    )
                  )
                ),
                _react2.default.createElement(
                  'tbody',
                  null,
                  documents ? documents.map(function (document, index) {
                    return _react2.default.createElement(
                      'tr',
                      { key: index },
                      _react2.default.createElement(
                        'td',
                        null,
                        document._id
                      ),
                      _react2.default.createElement(
                        'td',
                        null,
                        document.type
                      ),
                      _react2.default.createElement(
                        'td',
                        null,
                        _react2.default.createElement(
                          _reactRouter.Link,
                          { to: '/documents/' + document._id },
                          'Voir'
                        )
                      ),
                      _react2.default.createElement('td', null),
                      _react2.default.createElement('td', null),
                      _react2.default.createElement('td', null)
                    );
                  }) : null,
                  _react2.default.createElement(
                    'tr',
                    null,
                    _react2.default.createElement(
                      'td',
                      { colSpan: '6' },
                      'Aucun document.'
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return Documents;
}(_react.Component), _class2.propTypes = {
  documents: _react.PropTypes.array
}, _temp)) || _class) || _class);
exports.default = Documents;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Documents/Documents.js
// module id = 1187
// module chunks = 0